// user may opt to use registered_state instead of state when their delivery address is in a state that differs
// from the state their store is registered in.
export const getSelectedState = (
  registeredState?: string,
  state?: string,
  shippingToAnotherStateWithSalesTax?: boolean,
  confirmedNotEligibleForCertificate?: boolean
) => {
  if (
    shippingToAnotherStateWithSalesTax &&
    confirmedNotEligibleForCertificate &&
    registeredState
  ) {
    return registeredState ?? state;
  }
  return state;
};
